import { useEffect, useState } from "react";

// true only after the component has mounted in the browser.
// During prerender/hydration it stays false, so DOM-mutating third-party
// widgets (Swiper) don't break React's hydration match.
// The prerender script sets window.__PRERENDER__ so its snapshot also keeps
// these widgets out of the static HTML, matching the first client render.
export const useHydrated = () => {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined" && window.__PRERENDER__) return;
    setHydrated(true);
  }, []);
  return hydrated;
};
